export const getTabId = (value?: string | number) => `tab${value}`;
export const getPanelId = (value?: string | number) => `panel${value}`;
